import { defineRecipe } from "@chakra-ui/react"

export const inputRecipe = defineRecipe({
  base: {
    fontFamily: "body"
  },
  variants: {
    variant: {
      outline: {
        borderWidth: "1px",
        borderColor: "gray.300",
        color: "gray.700",
        pt: 2,
        pb: 2,
        pl: 4,
        pr: 4,
        borderRadius: 5,
        fontWeight: "bold",
        cursor: "pointer",
        _hover: { bg: "gray.100" },
        _disabled: { borderColor: "gray.100", color: "gray.300", cursor: "not-allowed" },
      },
    },
  },
  defaultVariants: {
    variant: "outline",
  },
})